import { EventEmitter, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  public webSocketError: EventEmitter<string> = new EventEmitter();
  private webSocket: WebSocket;

  constructor() { }

  /**
   * Function that activates and creates a websocket
   */
  activateWebSocket(): void {
    this.webSocket = new WebSocket('wss://devcom.apps.signaturit.com/ws');

    this.webSocket.onerror = () => {
      this.webSocketError.emit('message_webSocket_error');
    };
  }

  /**
   * Function that returns the actual websocket
   * @returns Actual websocket created
   */
  getWebSocket(): WebSocket {
    if (this.webSocket) {
      return this.webSocket;
    } else {
      return null;
    }
  }

  /**
   * Function that closes the actual websocket
   */
  closeWebSocket(): void {
    this.webSocket?.close();
    this.webSocket = null;
  }

}
